import { getDeferred } from './get-deferred';

export function waitForBoolean(
  condition: () => boolean,
  intervalMs = 50,
  timeoutMs = 10000
): Promise<boolean | null> {
  const conditionName = condition.name || 'anonymous function';
  const deferred = getDeferred<boolean>();
  let interval: ReturnType<typeof setInterval> = NaN;
  let timeout: ReturnType<typeof setTimeout> = NaN;

  interval = setInterval(() => {
    if (condition()) {
      clearInterval(interval);
      clearTimeout(timeout);
      return deferred.resolve(true);
    }
  }, intervalMs);

  timeout = setTimeout(() => {
    clearInterval(interval);
    return deferred.reject(
      new Error(
        `Failed to verify '${conditionName}' within ${timeoutMs} milliseconds.`
      )
    );
  }, timeoutMs);

  return deferred.promise;
}
